import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import ChatInput from "../components/ChatInput";
import QuickActions from "../components/QuickActions";
import "./Home.css";
import { getFromLocalStorage } from "../utils/Util";
import { STORAGE_KEY } from "../utils/Constant";
 
const Home: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);
  const [message, setMessage] = useState("");
  const [messageActive, setMessageActive] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentText, setCurrentText] = useState('');
  
  const handleActionClick = (action: string) => {
    setMessage(action);
    setMessageActive(true);
  };
 
  const handleTyping = (newMessage: string) => {
    setMessage(newMessage);
    if (newMessage.trim()) {
      setMessageActive(true);
    }
  };
 
  const authData: any = JSON.parse(getFromLocalStorage(STORAGE_KEY.AUTH_DATA));
  // console.log(authData);
  const fullName = authData?.employeeName  || "";
  const firstName = fullName?.split(" ")[1] || "User";
  // console.log(firstName, fullName);
 
  const delay = 100;
  useEffect(() => {
    const fullText = fullName + "..!";
    if (currentIndex < fullText.length) {
      const timeout = setTimeout(() => {
        setCurrentText((prevText) => prevText + fullText[currentIndex]);
        setCurrentIndex((prevIndex) => prevIndex + 1);
      }, delay);
 
      return () => clearTimeout(timeout);
    }
  }, [currentIndex, delay, firstName]);
 
 
  return (
    <div
      className="flex bg-gray-100"
      style={{ background: "#D0DAE766", height: "100vh" }}
    >
      <Sidebar
        isOpen={isSidebarOpen}
        toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
      />
      <div className="flex flex-col flex-1 p-6">
      <Header />
 
        {!messageActive && (
          <div className="flex flex-col flex-1 justify-center items-center text-center">
            <h1 className="welcome-text">Hey {currentText}</h1>
            <p className="welcome-text mt-[10px]">How can I help you today</p>
 
            <span className="assist-text mt-[12px]">
              I am ready to assist you with anything you need.
            </span>
          </div>
        )}
        <div className="flex flex-col flex-1 min-h-8" style={{ marginBottom: "20px" }}>
          <ChatInput message={message} setMessage={handleTyping} />
        </div>
        {!messageActive && (
          <QuickActions handleActionClick={handleActionClick} />
        )}
        <div className="mistakes">
        {/* KshemaGPT can make mistakes. Output generated may not be entirely correct */}
        KshemaGPT can make mistakes. Please give your feedback to improve it.
        </div>
      </div>
    </div>
  );
};
 
export default Home;